import { render, staticRenderFns } from "./jinkouPup.vue?vue&type=template&id=53ae99b3&scoped=true&"
import script from "./jinkouPup.vue?vue&type=script&lang=js&"
export * from "./jinkouPup.vue?vue&type=script&lang=js&"
import style0 from "./jinkouPup.vue?vue&type=style&index=0&id=53ae99b3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ae99b3",
  null
  
)

export default component.exports